/* eslint-disable no-param-reassign */
const autoGrow = (element: any, size: number) => {
  element.target.style.height = `${size}px`;
  element.target.style.height = `${element.target.scrollHeight}px`;
};

export default autoGrow;
